import { useTranslation } from 'react-i18next'

import { WarningIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { CardTitle, Text } from '@reveni-io/reveni-ui'

const SizingIssuesTitle = () => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <CardTitle Icon={WarningIcon} marginBottom={theme.spacing.sp4}>
      <Text type="titleM" color={theme.colors.accent.on}>
        {t('Problemas de talla de este producto')}
      </Text>
    </CardTitle>
  )
}

export default SizingIssuesTitle
